import { store } from '@/store';
import { time } from '@/utils/time';
import * as easing from '@hscmap/easing';
import { IJumpToOptions } from '@hscmap/stellar-globe/dist/types/globe/view_factory';
import { ICameraParams } from '@hscmap/stellar-globe/dist/types/view/matrilx-utils';

const timeScale = 1000

const WAIT = 10 * timeScale
const WAIT_BEFORE_START = 2 * timeScale
const DEFAULT_OPTIONS: Partial<IJumpToOptions> = {
  duration: 20 * timeScale,
  easingFunction: easing.slowStartStop4,
}

interface IStoppable {
  abort(): void
  promise: Promise<any>
}

class StoppableSleep implements IStoppable {
  readonly abort: () => void
  readonly promise: Promise<void>
  constructor(duration: number) {
    const { promise, abort } = time.cancellableSleep(duration)
    this.abort = abort
    this.promise = promise
  }
}

let animation: IStoppable | undefined

async function waitFor(a: IStoppable) {
  animation = a
  await a.promise
  animation = undefined
}

function startDemoPlay() {
  animation || setTimeout(async () => {
    const globe = store.currentGlobe()
    const vf = globe.viewFactory
    try {
      await waitFor(new StoppableSleep(WAIT_BEFORE_START))
      for (let i = 0; ; ++i) {
        const { params, options, wait } = program[i % program.length]
        await waitFor(vf.jumpTo(params, { ...DEFAULT_OPTIONS, ...(options || {}) }))
        await waitFor(new StoppableSleep(wait || WAIT))
      }
      // tslint:disable-next-line: no-empty
    } catch {
    }
  })
}

function stopDemoPlay() {
  if (animation) {
    animation.abort()
    animation = undefined
  }
}

const program: Array<{ params: Partial<ICameraParams>, options?: Partial<IJumpToOptions>, wait?: number }> = [
  // M31
  {
    // tslint:disable-next-line: max-line-length
    // params: { fovy: 0.012456081352014215, phi: 0.1876254314246708, roll: -2.2370645104981657, theta: 0.7194844552279407 },
    params: { fovy: 0.012456081352014215, phi: 0.1876254314246708, theta: 0.7194844552279407 },
  },
  // M31 Zoom
  {
    // tslint:disable-next-line: max-line-length
    // params: { phi: 0.18105966423482034, theta: 0.7129598538933686, roll: -1.2631662944278634, fovy: 0.0005384003578164332 },
    params: { phi: 0.18105966423482034, theta: 0.7129598538933686, roll: 0, fovy: 0.0005384003578164332 },
  },
  // M45
  { params: { phi: 0.9901265728687445, theta: 0.42097346885413534, roll: 0, fovy: 0.011765501725578496 } },
  // M42
  { params: { phi: 1.4632952011973464, theta: -0.09536593883346953, roll: 0, fovy: 0.006548073610507085 } },
  // M42 zoom
  { params: { phi: 1.4632952011973464, theta: -0.09536593883346953, roll: 0, fovy: 0.006548073610507085 } },
  // Open Cluster
  { params: { phi: 2.642102925430109, theta: 0.0012513581741364702, roll: 0, fovy: 0.0005529282893206677 } },
]

export { startDemoPlay, stopDemoPlay };
